import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <h1>Privacy Policy</h1>

      <div className="effective-date">Effective Date: 07/15/2025</div>

      <div className="intro-section">
        <p>
          Welcome to <strong>Scout Minion</strong>, a mobile application owned
          and operated by Yusra Institute LLC ("we", "our", or "us"). We are
          committed to protecting your privacy. This Privacy Policy explains how
          we collect, use, share, and safeguard your information when you use
          the Scout Minion application ("App") and related services.
        </p>

        <p>
          <strong>
            By using Scout Minion, you agree to the collection and use of
            information in accordance with this policy.
          </strong>
        </p>
      </div>

      <h2>1. Information We Collect</h2>

      <h3>a. Personal Information</h3>
      <div className="card">
        <p>
          When you use Scout Minion, we may collect the following personal
          information:
        </p>
        <ul>
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Amazon Seller Central credentials (via OAuth)</li>
          <li>Receipts and purchase records you upload</li>
          <li>Buy list and folder metadata</li>
        </ul>
      </div>

      <h3>b. Authentication and Authorization</h3>
      <div className="card">
        <ul>
          <li>
            We use Supabase to securely handle login, registration, and email
            verification.
          </li>
          <li>
            We store access tokens using JWT (JSON Web Tokens) for session
            management.
          </li>
        </ul>
      </div>

      <h3>c. Barcode and Product Data</h3>
      <div className="card">
        <ul>
          <li>Scanned barcode data</li>
          <li>Product details retrieved from Amazon and Keepa</li>
          <li>User-generated metadata (e.g., product notes, folders)</li>
        </ul>
      </div>

      <h3>d. Device and Usage Data</h3>
      <div className="card">
        <ul>
          <li>Device type and OS version</li>
          <li>
            Camera and storage permissions (used only locally for scanning and
            uploads)
          </li>
          <li>App usage logs (e.g., features accessed, scan history)</li>
        </ul>
      </div>

      <h2>2. How We Use Your Information</h2>
      <div className="card">
        <p>We use your information to:</p>
        <ul>
          <li>Authenticate and authorize access to the app</li>
          <li>Connect to your Amazon Seller account securely</li>
          <li>Fetch and display product and market data</li>
          <li>Generate AI-based purchase recommendations</li>
          <li>Manage and organize buy lists, folders, and receipts</li>
          <li>Provide onboarding and user guidance</li>
          <li>Improve our services and user experience</li>
          <li>Send important updates and account notifications</li>
        </ul>
      </div>

      <h2>3. Sharing and Disclosure</h2>
      <div className="highlight">
        <strong>We do not sell your personal data to third parties.</strong>
      </div>
      <div className="card">
        <p>We may share data under the following circumstances:</p>
        <ul>
          <li>
            <strong>Amazon SP-API & Keepa API:</strong> To retrieve real-time
            product data
          </li>
          <li>
            <strong>Supabase:</strong> For authentication and database services
          </li>
          <li>
            <strong>Legal Requirements:</strong> If required by law, subpoena,
            or regulatory request
          </li>
          <li>
            <strong>Service Providers:</strong> Who assist with backend
            infrastructure, analytics, or customer support under strict
            confidentiality agreements
          </li>
        </ul>
      </div>

      <h2>4. Data Security</h2>
      <div className="card">
        <p>We use best-in-class practices to protect your data:</p>
        <ul>
          <li>End-to-end encryption of sensitive tokens</li>
          <li>OAuth for secure Amazon account integration</li>
          <li>Rate limiting and request validation on APIs</li>
          <li>Regular security audits and monitoring</li>
          <li>Access restricted to authorized personnel only</li>
        </ul>
      </div>

      <h2>5. Your Choices and Rights</h2>
      <div className="card">
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your personal information</li>
          <li>Delete your account and associated data</li>
          <li>Revoke access to your Amazon Seller account</li>
          <li>Opt out of non-essential communications</li>
          <li>Request a copy of your stored data</li>
        </ul>
        <p>To exercise these rights, please contact: belal.nayeem1@gmail.com</p>
      </div>

      <h2>6. Data Retention</h2>
      <div className="card">
        <p>We retain your data only as long as necessary to:</p>
        <ul>
          <li>Provide you with app services</li>
          <li>Comply with legal obligations</li>
          <li>Resolve disputes or enforce our terms</li>
        </ul>
        <p>
          <strong>
            Scan history, buy lists, and receipts can be deleted manually at any
            time by the user.
          </strong>
        </p>
      </div>

      <h2>7. Children's Privacy</h2>
      <div className="card">
        <p>
          Scout Minion is not intended for children under the age of 13. We do
          not knowingly collect personal data from children. If you believe a
          child has provided us with personal information, please contact us
          immediately.
        </p>
      </div>

      <h2>8. Changes to This Privacy Policy</h2>
      <div className="card">
        <p>
          We may update this policy from time to time. We will notify you of any
          material changes via email or in-app notifications. Continued use of
          the app constitutes your acceptance of the revised policy.
        </p>
      </div>

      <h2>9. International Users</h2>
      <div className="card">
        <p>
          If you are accessing the app from outside the United States, your data
          may be transferred to and stored in the U.S. By using the app, you
          consent to this transfer in compliance with applicable laws.
        </p>
      </div>

      <h2>10. Contact Us</h2>
      <div className="contact-info">
        <p>
          If you have questions or concerns about this Privacy Policy, please
          contact us at:
        </p>
        <br />
        <p>
          <strong>Yusra Institute LLC</strong>
          <br />
          Email: belal.nayeem1@gmail.com
          <br />
        </p>
      </div>

      <div className="read-the-docs">
        <p>
          <em>
            This privacy policy was last updated on the effective date listed
            above.
          </em>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
